import React, { CSSProperties } from 'react'

import s from './styles.module.scss'

export const EmptySquareImage = ({
  style,
  children,
}: {
  style?: CSSProperties
  children: React.ReactNode
}) => {
  return (
    <div className={s.container} style={style}>
      {children}
    </div>
  )
}
